import { DataService } from "./data";

export interface RecentRecord {
    id: number;
    reference_type: number;
    reference_type_name: string;
    reference_id: number;
    object_name: string;
    object_url: string;
    created_at: string;
}

export interface CreateRecentRecordData {
    reference_type_name: string;
    reference_id: number;
}

export interface RecentRecordsByType {
    [key: string]: RecentRecord[];
}

export interface PaginatedResponse<T> {
    count: number;
    next: string | null;
    previous: string | null;
    results: T[];
}

export const RecentRecordService = {
    list: (params?: Record<string, any>) =>
        DataService.client
            .url("/crm/app/recent-records/")
            .query(params || {})
            .get()
            .json() as Promise<PaginatedResponse<RecentRecord>>,

    create: (data: CreateRecentRecordData) => DataService.client.url("/crm/app/recent-records/").post(data).json() as Promise<RecentRecord>,

    byType: () => DataService.client.url("/crm/app/recent-records/by_type/").get().json() as Promise<RecentRecordsByType>,

    byReferenceType: async (referenceType: string): Promise<RecentRecord[]> => {
        console.log("byReferenceType", referenceType);
        const response = (await DataService.client.url("/crm/app/recent-records/").query({ reference_type: referenceType }).get().json()) as PaginatedResponse<RecentRecord>;

        // Retourne juste les résultats du tableau paginé
        return response.results || [];
    },

    byReferenceTypeId: async (referenceTypeId: number): Promise<RecentRecord[]> => {
        const response = (await DataService.client
            .url("/crm/app/recent-records/")
            .query({ reference_type_id: referenceTypeId, page_size: 100 })
            .get()
            .json()) as PaginatedResponse<RecentRecord>;

        return response.results || [];
    }
};
